import { Util } from '@/Util';
import { EmptyFilter } from './Dto';
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import { Place } from '@/Dto';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    view: 'List',
    places: new Array<Place>(),
    tags: new Array<string>(),
    filter: new EmptyFilter(),
    selectedPlace: -1
  },
  mutations: {
    updatePlaces(state, payload) {
      state.selectedPlace = -1;
      state.places = payload || new Array<Place>();
      let tags = new Array<string>();

      for (const place of state.places) {
        if (place.tags) {
          tags = tags.concat(place.tags);
        }
      }

      state.tags = tags.filter((tag, index, self) => self.indexOf(tag) === index);
    },
    updateFilterSearch(state, payload) {
      state.selectedPlace = -1;
      state.filter.search = payload || '';
    },
    toggleView(state, payload) {
      state.view = state.view === 'Map' ? 'List' : 'Map';
    },
    selectPlace(state, payload) {
      if (payload === undefined || payload === state.selectedPlace) {
        state.selectedPlace = -1;
      } else {
        state.selectedPlace = payload;
      }
    }
  },
  getters: {
    view: (state, getters) => state.view,
    filteredPlaces: (state, getters) => state.places.filter((place) => {
      const keys:Array<string> = state.filter.search.toLocaleLowerCase().split(" ");
      const matches = keys.filter(key => {
        if (key.trim() === '') {
          return true;
        }
        return place.index.find(index => Util.contains(index, key));
      });
      return matches.length === keys.length;
    }),
    filteredTags: (state, getters) => getters.tags.filter((tag: string) => {
      if (!state.filter.search) {
        return false;
      }
      if (!Util.contains(tag, state.filter.search)) {
        return false;
      }
      return true;
    }),
    tags: (state, getters) => state.tags,
    filter: (state, getters) => state.filter,
    selectedPlace: (state, getters) => {
      return state.selectedPlace >= 0 ? getters.filteredPlaces[state.selectedPlace] : null;
    },
    selectedPlaceIndex: (state, getters) => {
      return state.selectedPlace >= 0 ? state.selectedPlace : null;
    },
  },
  actions: {
    fetchPlaces({ commit }) {
      axios.get(process.env.VUE_APP_PLACES_API).then(
        response => {
          const places:Array<Place> = response.data.map((place:Place) => {
            place.index = new Array<string>();
            if (place.address) {
              place.index = Util.concat(place.index, place.address.city);
              place.index = Util.concat(place.index, place.address.district);
              place.index = Util.concat(place.index, place.address.number);
              place.index = Util.concat(place.index, place.address.postCode);
              place.index = Util.concat(place.index, place.address.street);
              place.index = Util.concat(place.index, place.address.suburb);
            }
            place.index = Util.concat(place.index, place.name);
            place.index = place.index.concat(place.tags);
            return place;
          });
          commit('updatePlaces', places);
        },
        (error) => {
          console.error(error);
        },
      );
    },
  },
});
